import { defineMessages } from '@sm/intl';
import PROJECT_NAME from '~app/pages/Pricing/constants/project';

import { TYPE_HEADER, TYPE_PARAGRAPH } from '~pricing/lib/PackageFeatures/tooltipCopy';

export default defineMessages({
  analyze_export_enabled_tooltip: {
    id: 'Pricing.tooltipCopyOverrides.DetailsAnalyzeExportEnabledTooltip',
    defaultMessage: 'N/A', // These are are overrides not to show the toop tip either in details or summary
    desc: {
      id: 'Pricing.tooltipCopyOverrides.DetailsAnalyzeExportEnabledTooltip',
      message: `${TYPE_PARAGRAPH} - DetailsAnalyzeExportEnabledTooltip`,
      project: PROJECT_NAME,
    },
  },
  analyze_export_spss_enabled_tooltip: {
    id: 'Pricing.tooltipCopyOverrides.DetailsAnalyzeExportSPSSEnabledTooltip',
    defaultMessage: 'N/A',
    desc: {
      id: 'Pricing.tooltipCopyOverrides.DetailsAnalyzeExportSPSSEnabledTooltip',
      message: `${TYPE_PARAGRAPH} - DetailsAnalyzeExportSPSSEnabledTooltip`,
      project: PROJECT_NAME,
    },
  },
  phone_support_tooltip: {
    id: 'Pricing.tooltipCopyOverrides.DetailsPhoneSupportTooltip',
    defaultMessage: 'N/A',
    desc: {
      id: 'Pricing.tooltipCopyOverrides.DetailsPhoneSupportTooltip',
      message: `${TYPE_PARAGRAPH} - DetailsPhoneSupportTooltip`,
      project: PROJECT_NAME,
    },
  },
  email_support_tooltip: {
    id: 'Pricing.tooltipCopyOverrides.DetailsEmailSupportTooltip',
    defaultMessage: 'N/A',
    desc: {
      id: 'Pricing.tooltipCopyOverrides.DetailsEmailSupportTooltip',
      message: `${TYPE_PARAGRAPH} - DetailsEmailSupportTooltip`,
      project: PROJECT_NAME,
    },
  },
  priority_email_support_tooltip: {
    id: 'Pricing.tooltipCopyOverrides.DetailsPriorityEmailSupportTooltip',
    defaultMessage: 'N/A',
    desc: {
      id: 'Pricing.tooltipCopyOverrides.DetailsPriorityEmailSupportTooltip',
      message: `${TYPE_PARAGRAPH} - DetailsPriorityEmailSupportTooltip`,
      project: PROJECT_NAME,
    },
  },
  analyze_combine_filters_tooltip_heading: {
    id: 'Pricing.tooltipCopyOverrides.DetailsCombineFiltersTooltipHeading',
    defaultMessage: 'Filter and compare results',
    desc: {
      id: 'Pricing.tooltipCopyOverrides.DetailsCombineFiltersTooltipHeading',
      message: `${TYPE_HEADER} - DetailsCombineFiltersTooltipHeading`,
      project: PROJECT_NAME,
    },
  },
  analyze_combine_filters_tooltip: {
    id: 'Pricing.tooltipCopyOverrides.DetailsCombineFiltersTooltip',
    defaultMessage:
      'Filter your results and compare how different groups answered the questions in your survey. Segment your data to uncover trends and correlations in your data.',
    desc: {
      id: 'Pricing.tooltipCopyOverrides.DetailsCombineFiltersTooltip',
      message: `${TYPE_PARAGRAPH} - DetailsCombineFiltersTooltip`,
      project: PROJECT_NAME,
    },
  },
  create_logo_enabled_tooltip_heading: {
    id: 'Pricing.tooltipCopyOverrides.DetailsCreateLogoEnabledTooltipHeading',
    defaultMessage: 'Add your logo',
    desc: {
      id: 'Pricing.tooltipCopyOverrides.DetailsCreateLogoEnabledTooltipHeading',
      message: `${TYPE_HEADER} - DetailsCreateLogoEnabledTooltipHeading`,
      project: PROJECT_NAME,
    },
  },
  create_logo_enabled_tooltip: {
    id: 'Pricing.tooltipCopyOverrides.DetailsCreateLogoEnabledTooltip',
    defaultMessage: `Make your survey stand out. Add a custom image or logo, and personalize the work you send.`,
    desc: {
      id: 'Pricing.tooltipCopyOverrides.DetailsCreateLogoEnabledTooltip',
      message: `${TYPE_PARAGRAPH} - DetailsCreateLogoEnabledTooltip`,
      project: PROJECT_NAME,
    },
  },
  create_piping_enabled_tooltip_heading: {
    id: 'Pricing.tooltipCopyOverrides.DetailsCreatePipingEnabledTooltipHeading',
    defaultMessage: 'Question & answer piping',
    desc: {
      id: 'Pricing.tooltipCopyOverrides.DetailsCreatePipingEnabledTooltipHeading',
      message: `${TYPE_HEADER} - DetailsCreatePipingEnabledTooltipHeading`,
      project: PROJECT_NAME,
    },
  },
  create_piping_enabled_tooltip: {
    id: 'Pricing.tooltipCopyOverrides.DetailsCreatePipingEnabledTooltip',
    defaultMessage: `Take respondents' answers from a previous question to personalize questions on a later page in the survey.`,
    desc: {
      id: 'Pricing.tooltipCopyOverrides.DetailsCreatePipingEnabledTooltip',
      message: `${TYPE_PARAGRAPH} - DetailsCreatePipingEnabledTooltip`,
      project: PROJECT_NAME,
    },
  },
  quizzes_pro_tooltip_heading: {
    id: 'Pricing.tooltipCopyOverrides.DetailsQuizzesProTooltipHeading',
    defaultMessage: 'Quizzes pro',
    desc: {
      id: 'Pricing.tooltipCopyOverrides.DetailsQuizzesProTooltipHeading',
      message: `${TYPE_HEADER} - DetailsQuizzesProTooltipHeading`,
      project: PROJECT_NAME,
    },
  },
  quizzes_pro_tooltip: {
    id: 'Pricing.tooltipCopyOverrides.DetailsQuizzesProTooltip',
    defaultMessage:
      'Show custom feedback for correct, partially correct, and incorrect responses as people take your quiz. At the end, show people custom feedback based on their overall score. Quizzes Pro also lets you email people their quiz results automatically, or export your quiz statistics in PDF, XLS, and CSV format.',
    desc: {
      id: 'Pricing.tooltipCopyOverrides.DetailsQuizzesProTooltip',
      message: `${TYPE_PARAGRAPH} - DetailsQuizzesProTooltip`,
      project: PROJECT_NAME,
    },
  },
});
